import { render, staticRenderFns } from "./IncomingDocument.vue?vue&type=template&id=62456b25&scoped=true&"
import script from "./IncomingDocument.vue?vue&type=script&lang=js&"
export * from "./IncomingDocument.vue?vue&type=script&lang=js&"
import style0 from "./IncomingDocument.vue?vue&type=style&index=0&id=62456b25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62456b25",
  null
  
)

export default component.exports